import type { Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'

import type { BidDirection } from '@/features/bidding/types/bidLadderInput'

type BarColors = {
  /** Light background color for bar segments (20% opacity) */
  barColor: string
  /** Full color for text, borders, and highlights */
  barColorDark: string
  /** Medium color for hover states and previews (40% opacity) */
  barColorMedium: string
}

function getBaseColor(theme: Theme, direction?: BidDirection): string {
  if (direction === 'up') {
    return theme.palette.success.main
  }
  if (direction === 'down') {
    return theme.palette.error.main
  }
  return theme.palette.primary.main
}

/**
 * Returns bar colors based on direction.
 * - 'up' direction: success (green) colors
 * - 'down' direction: error (red) colors
 * - undefined (symmetrical): primary (blue) colors
 */
function getBarColors(theme: Theme, direction?: BidDirection): BarColors {
  const baseColor = getBaseColor(theme, direction)

  return {
    barColor: alpha(baseColor, 0.2),
    barColorDark: baseColor,
    barColorMedium: alpha(baseColor, 0.4),
  }
}

export { getBarColors }
export type { BarColors }
